import React from 'react';
import { useTranslation } from 'react-i18next';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

/**
 * @description This function lets you return component according to the name of the incoming action.
 * @param       action - object
 * @returns     JSX.Element
 * @author      ibrahim AKIN
 */
function Save({ action, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.SAVE.';

    return (
        <>
            <div>
                <div className="form-element">
                    {t(label + 'EXCEL-SOURCE')}
                    <VariablePicker action={action} inputName="excelSource" variables={variables}
                        setOpenVariable={setOpenVariable} filter="data table" isRequired />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                </div>
                <div className="form-element">
                    {t(label + 'FOLDER-PATH')}
                    <TextInput action={action} inputName="folderPath" setOpenVariable={setOpenVariable}
                        variables={variables} isRequired />
                    <small><em>e.g.    C:\Autommate\test</em></small>
                </div>
                <div className="form-element">
                    {t(label + 'ASSIGN-PATH')}
                    <VariablePicker action={action} inputName="assignToVariable" variables={variables}
                        setOpenVariable={setOpenVariable} filter="string" />
                    <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
                </div>
            </div>
        </>
    )
}

export default Save;
